import "./spinner.css"

export const Spinner  = () => {
    return (
        <div className="spinner-wrap">
            <div className="spinner-border " role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}